import axios from 'axios';
import { API_URL } from './api';

export const BUSINESS_API_BASE = `${API_URL}/api/business`;

const _err = (error) => {
    if (error.response) {
        console.error('Business auth error:', error.response.status, error.response.data);
    } else {
        console.error('Business auth error:', error.message);
    }
};

const auth = (token) => ({
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
});

export const APIBusinessRegister = async (data) => {
    try {
        const r = await axios.post(`${BUSINESS_API_BASE}/auth/register/`, data);
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessVerifyEmail = async (token) => {
    try {
        const r = await axios.post(`${BUSINESS_API_BASE}/auth/verify-email/`, { token });
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessLogin = async (email, password) => {
    try {
        const r = await axios.post(`${BUSINESS_API_BASE}/auth/login/`, { email, password });
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessMe = async (token) => {
    try {
        const r = await axios.get(`${BUSINESS_API_BASE}/auth/me/`, auth(token));
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessUpdateProfile = async (token, data) => {
    try {
        const r = await axios.patch(`${BUSINESS_API_BASE}/auth/profile/`, data, auth(token));
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessForgotPassword = async (email) => {
    try {
        const r = await axios.post(`${BUSINESS_API_BASE}/auth/password/forgot/`, { email });
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessResetPassword = async (token, password) => {
    try {
        const r = await axios.post(
            `${BUSINESS_API_BASE}/auth/password/reset/`, { token, password }
        );
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIBusinessChangePassword = async (token, currentPassword, newPassword) => {
    try {
        const r = await axios.post(
            `${BUSINESS_API_BASE}/auth/password/change/`,
            { current_password: currentPassword, new_password: newPassword },
            auth(token),
        );
        return r.data;
    } catch (e) { _err(e); throw e; }
};


export const APIBusinessReferral = async (token) => {
    try {
        const r = await axios.get(`${BUSINESS_API_BASE}/referral/me/`, auth(token));
        return r.data;
    } catch (e) {
        throw e;
    }
};